<template>
  <div class="d-active" :class="{bottom: position === 'bottom'}">
    <div class="menu">
      <div class="m-item" @click.stop="selectItem(item)" v-for="(item, i) in list" :key="i">
        <div class="c">
          <span class="group">{{ item.id }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {};
  },
  props: ['list', 'callback', 'position'],
  methods: {
    selectItem(item) {
      this.callback.call(this, item)
    },
  },
};
</script>
<style scoped>
.bottom {
  align-items: flex-start;
  top: unset;
  bottom: -5px;
}

.m-item {
  padding: 3px 0;
  height: 25px;
}

.menu {
  max-height: 250px;
  overflow: auto;
}
</style>